import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { Plus, Send, FileEdit } from "lucide-react";

export default function AdminProposals() {
  const [items, setItems] = useState([]);
  const [companies, setCompanies] = useState([]);
  const refresh = () => api.get("/payments/proposals").then(r => setItems(r.data || [])).catch(() => {});
  useEffect(() => { refresh(); api.get("/companies/").then(r => setCompanies(r.data || [])).catch(() => {}); }, []);

  const [form, setForm] = useState({ company_id: "", title: "", description: "", monthly_fee: "", activation_fee: "", total: "" });
  const create = async () => {
    try {
      const payload = { ...form };
      ["monthly_fee","activation_fee","total"].forEach(k => { if (payload[k] === "") delete payload[k]; else payload[k] = parseFloat(payload[k]); });
      await api.post("/payments/proposals", payload);
      toast.success("Proposta creata");
      setForm({ company_id: "", title: "", description: "", monthly_fee: "", activation_fee: "", total: "" });
      refresh();
    } catch (e) { toast.error("Errore"); }
  };

  const send = async (id) => {
    try { await api.post(`/payments/proposals/${id}/send`); toast.success("Proposta inviata"); refresh(); }
    catch (e) { toast.error("Errore"); }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="font-display text-2xl font-bold text-slate-900">Proposte</h1>
          <p className="text-sm text-slate-600">Crea, gestisci e invia proposte commerciali alle aziende.</p>
        </div>
        <Dialog>
          <DialogTrigger asChild><Button className="bg-[#2D6BFF] text-white"><Plus size={14} className="mr-1" /> Nuova proposta</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Nuova proposta</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Azienda</Label><Select value={form.company_id} onValueChange={v => setForm({...form, company_id: v})}><SelectTrigger><SelectValue placeholder="Seleziona" /></SelectTrigger><SelectContent>{companies.map(c => <SelectItem key={c.id} value={c.id}>{c.company_name}</SelectItem>)}</SelectContent></Select></div>
              <div><Label>Titolo</Label><Input value={form.title} onChange={e => setForm({...form, title: e.target.value})} /></div>
              <div><Label>Descrizione</Label><Textarea rows={3} value={form.description} onChange={e => setForm({...form, description: e.target.value})} /></div>
              <div className="grid grid-cols-3 gap-2">
                <div><Label>Attivazione €</Label><Input type="number" value={form.activation_fee} onChange={e => setForm({...form, activation_fee: e.target.value})} /></div>
                <div><Label>Mensile €</Label><Input type="number" value={form.monthly_fee} onChange={e => setForm({...form, monthly_fee: e.target.value})} /></div>
                <div><Label>Totale €</Label><Input type="number" value={form.total} onChange={e => setForm({...form, total: e.target.value})} /></div>
              </div>
            </div>
            <DialogFooter><Button onClick={create} disabled={!form.title || !form.company_id} className="bg-[#2D6BFF] text-white">Crea</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
      <div className="space-y-3">
        {items.map(p => (
          <div key={p.id} className="cxo-card p-5 flex items-center gap-4">
            <FileEdit className="text-[#2D6BFF]" size={18} />
            <div className="flex-1">
              <h3 className="font-semibold text-slate-900">{p.title}</h3>
              <p className="text-xs text-slate-500">{p.description}</p>
              <div className="mt-1 text-xs cxo-tabular">€{(p.total || 0).toLocaleString('it-IT')}</div>
            </div>
            <Badge className="border-0">{p.status}</Badge>
            {p.status === "draft" && <Button size="sm" onClick={() => send(p.id)} className="bg-[#2D6BFF] text-white"><Send size={14} className="mr-1" /> Invia</Button>}
          </div>
        ))}
      </div>
    </div>
  );
}
